import { type SessionUser } from 'types/auth';
import { SubscriptionTier } from 'types/team';

export interface GetStartedProgress {
  has_sources: boolean;
  has_queried: boolean;
  has_deployed: boolean;
  has_explored_analytics: boolean;
  is_hidden: boolean;
}

export const isGetStartedEligible = (user?: SessionUser): boolean =>
  user?.team?.tier === SubscriptionTier.Free;

export const getStartedProgressKey = (teamId?: string) =>
  ['team', teamId, 'get-started'] as const;
